import React from 'react';
import PropTypes from 'prop-types';

import styles from './Rooms.module.css';
import data from '../../data';

const { general } = data;

const Icon = ({ zoomedIconConfig, zoomOutHandler }) => {
  const { nameIcon, yearIcon, icon, openDetail } = zoomedIconConfig;

  return (
    <div className={`${styles.centerIcon} info-icon`}>
      <div>
        <div
          className={`${styles.out} ${styles.setPulse} info-icon`}
          onClick={() => {
            const { type, data } = zoomedIconConfig;
            openDetail(type, data);
            zoomOutHandler(zoomedIconConfig.index);
          }}
        >
          <img alt="" src={icon} className={`${styles.iconSvg} info-icon`} />
        </div>
      </div>
      <div className={styles.centerNameAndYear}>
        <div>{nameIcon}</div>
        <div>{yearIcon}</div>
      </div>
    </div>
  );
};

Icon.propTypes = {
  zoomedIconConfig: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  zoomOutHandler: PropTypes.func,
};

const BottomNavRoom = ({
  links,
  title,
  zoomedIcon,
  zoomedIconConfig,
  history,
  showNextRoom,
  showPrevRoom,
  isMobile,
  disableNavButtons,
  zoomOutHandler,
}) => {
  const next =
    'https://res.cloudinary.com/arts/image/upload/v1598431007/max-braun/rooms/icons/room-next.svg';
  const back =
    'https://res.cloudinary.com/arts/image/upload/v1598431008/max-braun/rooms/icons/room-back.svg';
  return (
    <>
      <div className={styles.goPreviousRoom}>
        <div
          onClick={() => {
            if (!disableNavButtons) {
              if (zoomedIcon) {
                setTimeout(() => {
                  showPrevRoom(links.previous.id);
                }, 1500);
                zoomOutHandler(zoomedIconConfig.index);
              } else {
                showPrevRoom(links.previous.id);
              }
            }
          }}
          className={styles['color--white']}
        >
          <img
            alt="arrow"
            className={`${styles.arrow} ${styles['padding-left--0']} ${styles['padding-right--2vw']}`}
            src={back}
          />
          <span>
            {isMobile
              ? links.previous.label
              : links.previous.label.replace(/\s/g, '')}
          </span>
        </div>
      </div>

      {zoomedIcon ? (
        <>
          <div className={styles.tooltipInfo}>{general.tapForMore}</div>
          <Icon
            zoomedIconConfig={zoomedIconConfig}
            zoomOutHandler={zoomOutHandler}
            history={history}
          />
        </>
      ) : (
        <div className={styles.interval} id="interval">
          {title}
        </div>
      )}
      <div className={styles.goNextRoom}>
        <div
          onClick={() => {
            if (!disableNavButtons) {
              if (zoomedIcon) {
                setTimeout(() => {
                  showNextRoom(links.next.id);
                }, 1500);
                zoomOutHandler(zoomedIconConfig.index);
              } else {
                showNextRoom(links.next.id);
              }
            }
          }}
          className={styles['color--white']}
        >
          <span>
            {isMobile ? links.next.label : links.next.label.replace(/\s/g, '')}
          </span>
          <img
            alt="arrow"
            className={`${styles.arrow} ${styles['padding-right--0']} ${styles['padding-left--2vw']}`}
            src={next}
          />
        </div>
      </div>
    </>
  );
};

BottomNavRoom.defaultProps = {
  zoomedIcon: false,
};

BottomNavRoom.propTypes = {
  links: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  title: PropTypes.string,
  zoomedIcon: PropTypes.bool,
  zoomedIconConfig: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  history: PropTypes.string,
  showNextRoom: PropTypes.func,
  showPrevRoom: PropTypes.func,
  isMobile: PropTypes.bool,
  disableNavButtons: PropTypes.bool,
  zoomOutHandler: PropTypes.func,
};

export default BottomNavRoom;
